module.exports = __webpack_public_path__ + "files/342a1a0f4f06c3edc4da6dc6cb72dab0.png";